import React from 'react'

import Box from 'components_new/atoms/Box'
import Chip from 'components_new/atoms/Chip'

import { FilterBarProps } from '.'

import { useTranslation } from 'language/translator'

const Desktop = (props: FilterBarProps) => {
  const {
    filter,
    orientation,
    readOnly,
    resetUserInput = () => {},
    setFilter = () => {},
    size,
    sx
  } = props
  const { t } = useTranslation()

  // success
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        gap: 0.5,
        ...(orientation === 'vertical'
          ? { flexWrap: 'wrap' }
          : {
              overflowX: 'auto',
              '&::-webkit-scrollbar': {
                height: 5
              },
              '&::-webkit-scrollbar-track': {
                boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'action.disabled',
                borderRadius: 2.5,
                outline: 'none'
              }
            }),
        ...sx
      }}
    >
      {filter.map((f1, i) => (
        <Chip
          key={i}
          color="primary"
          label={
            (f1.display_value ?? f1.value) === null
              ? t('global', 'missing_value')
              : f1.display_value ?? f1.value
          }
          onDelete={
            readOnly
              ? undefined
              : () =>
                  setFilter(
                    filter.filter(
                      (f2) =>
                        f2.attribute !== f1.attribute || f2.value !== f1.value
                    )
                  )
          }
          size={size ?? 'small'}
        />
      ))}
      {readOnly ? null : (
        <Chip
          clickable={true}
          label={t('global', 'clear_all')}
          onClick={resetUserInput}
          size={size ?? 'small'}
        />
      )}
    </Box>
  )
}

export default Desktop
